<template>
  <v-card color="transparent" elevation="0">
    <v-data-table
      :headers="headers"
      :items="customers"
      :search="search"
      :items-per-page="15"
      sort-by="name"
      class="elevation-0 transparent"
      dense
    >
      <template v-slot:top>
        <v-toolbar flat class="transparent">
          <v-toolbar-title>Zákazníci</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.created="{ item }">
        <span>{{ item.created | moment("Do MMMM YYYY") }}</span>
      </template>
      <template v-slot:item.lastLogin="{ item }">
        <span>{{ item.lastLogin | moment("Do MMMM YYYY, HH:mm:ss") }}</span>
      </template>
      <template v-slot:item.action="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              color="primary"
              dark
              v-on="on"
              @click="{{item.customerGuid}}"
            >mdi-arrow-right-bold-box</v-icon>
          </template>
          <span>EDIT NEFUNGUJE</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { tableHeader } from "../js/customer";

export default {
  name: "CustomerList",
  data: () => ({
    headers: tableHeader,
    customers: [],
    search: ""
  }),

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.openGlobalLoader("Načítava sa ...");
      this.services
        .customerService()
        .getCustomers()
        .then(response => {
          this.customers = response.data;
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    }
  }
};
</script>
